export interface IHeaderMessages {
	goBack: string;
	goTop: string;
}

export const defaultMessages: IHeaderMessages = {
	goBack: "back",
	goTop: "top",
};